(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["c24-order-units"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-c24-order]').forEach(function(panel){
  var form=panel.closest('form'),quantity=form&&form.querySelector('[name="quantity"]');
  if(!quantity)return;
  var boxes=Number(panel.dataset.boxes),price=Number(panel.dataset.price);
  var currency=new Intl.NumberFormat('en-AU',{style:'currency',currency:panel.dataset.currency});
  var summary=panel.querySelector('[data-c24-summary]'),error=panel.querySelector('[data-c24-error]');
  quantity.required=true;quantity.step='1';
  quantity.setAttribute('aria-label',panel.querySelector('[data-c24-quantity-label]').textContent.trim());
  function sync(){
    var raw=quantity.value.trim(),count=Number(raw),total=count*price,clipCount=count*boxes*10000;
    var valid=/^[0-9]+$/.test(raw)&&count>0&&Number.isSafeInteger(count)&&Number.isSafeInteger(total)&&Number.isSafeInteger(clipCount);
    quantity.setCustomValidity(valid?'':panel.dataset.invalid);
    summary.hidden=!valid;error.hidden=valid;error.textContent=valid?'':panel.dataset.invalid;
    var sticky=document.getElementById('stickybar'),stickyPrice=sticky&&sticky.querySelector('#s-price');
    if(sticky){
      sticky.classList.add('stickybar--c24');
      if(stickyPrice)stickyPrice.textContent=valid?panel.dataset.stickyLabel+' '+currency.format(total/100):panel.dataset.invalid;
    }
    if(valid){
      panel.querySelector('[data-c24-box-count]').textContent=(count*boxes).toLocaleString('en-AU');
      panel.querySelector('[data-c24-clip-count]').textContent=clipCount.toLocaleString('en-AU');
      panel.querySelector('[data-c24-subtotal]').textContent=currency.format(total/100);
    }
    return valid;
  }
  quantity.addEventListener('input',sync);quantity.addEventListener('change',sync);
  form.addEventListener('submit',function(event){if(!sync()){event.preventDefault();event.stopImmediatePropagation();quantity.reportValidity();}},true);
  sync();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["daryl-contact-tracking"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__outbackDarylContactTracking) return;
  window.__outbackDarylContactTracking = true;

  var privacyRequested = false;

  function loadPrivacy() {
    var shopify = window.Shopify;
    if (!shopify || shopify.customerPrivacy || privacyRequested || typeof shopify.loadFeatures !== 'function') return;
    privacyRequested = true;
    try {
      shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
    } catch (error) {
      privacyRequested = false;
    }
  }

  function processingAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return false;
    try {
      return typeof privacy.analyticsProcessingAllowed === 'function' &&
        privacy.analyticsProcessingAllowed() === true &&
        typeof privacy.marketingAllowed === 'function' &&
        privacy.marketingAllowed() === true &&
        typeof privacy.saleOfDataAllowed === 'function' &&
        privacy.saleOfDataAllowed() === true;
    } catch (error) {
      return false;
    }
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.isTrusted === false || (typeof event.button === 'number' && event.button !== 0)) return;
    var target = event.target;
    if (target && target.nodeType === 3) target = target.parentElement;
    var link = target && typeof target.closest === 'function' ? target.closest('a[href]') : null;
    if (!link) return;
    var href = link.getAttribute('href') || '';
    var match = href.trim().match(/^(tel|sms):\s*([^?&#;]+)(?:[?&#;].*)?$/i);
    if (!match) return;
    var number = match[2].replace(/[\s().-]/g, '');
    if (number !== '0421572245' && number !== '+61421572245') return;

    loadPrivacy();
    if (!processingAllowed()) return;
    var shopify = window.Shopify;
    if (!shopify.analytics || typeof shopify.analytics.publish !== 'function') return;
    try {
      var published = shopify.analytics.publish('outback:contact_click', {
        method: match[1].toLowerCase() === 'tel' ? 'call' : 'text',
        contact_route: 'daryl'
      });
      if (published && typeof published.catch === 'function') published.catch(function () {});
    } catch (error) {}
  });

  loadPrivacy();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadPrivacy, { once: true });
}());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-restock-form"] && !Shopify.designMode) return;
  try {
    (function () {
    var form = document.getElementById('RestockCustomerForm');
    if (!form) return;
    var key = 'ob_restock_submit';
    var response = form.querySelector('[data-restock-response]');
    var ownResponse = false;
    try {
      var intent = JSON.parse(sessionStorage.getItem(key) || 'null');
      var age = intent && Date.now() - intent.at;
      ownResponse = Boolean(response && intent && intent.path === window.location.pathname && age >= 0 && age <= 600000);
    } catch (_) {}
    document.addEventListener('submit', function (event) {
      var target = event.target;
      var type = target.querySelector && target.querySelector('input[name="form_type"]');
      if (event.defaultPrevented || !type || type.value !== 'customer') return;
      try {
        if (target === form) sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), path: window.location.pathname }));
        else { sessionStorage.removeItem(key); ownResponse = false; }
      } catch (_) {}
    });
    function showOwnResponse() {
      if (!ownResponse) return;
      if (document.documentElement.classList.contains('no-scroll') || document.querySelector('#cart-drawer.is-open, #nav-drawer.is-open')) {
        setTimeout(showOwnResponse, 8000);
        return;
      }
      ownResponse = false;
      try { sessionStorage.removeItem(key); } catch (_) {}
      if (response.hasAttribute('data-restock-success')) {
        var copy = response.querySelector('[data-restock-copy]');
        copy.textContent = copy.dataset.successCopy;
        form.querySelector('[data-restock-fields]').hidden = true;
      }
      response.focus();
    }
    showOwnResponse();
  }());
  } catch(e) { console.error(e); }
})();

})();
